module.exports = __webpack_public_path__ + "static/media/zgoda_na_leczenie_beneslider_mikroimplant.f1c1296a.pdf";